import { LandingPage } from './pages/LandingPage';

// The public marketing site is a single page. No router needed — in-page
// anchors (#services, #about, #contact) handle navigation, and the
// "Employee Login" links out to the dashboard host (app.stfors.com).
export function App(): JSX.Element {
  return <LandingPage />;
}
